import React, { Component } from 'react';
import { Col, DatePicker, Form, Modal, Row } from 'antd';

import { queryBusinessInfo, queryCustomList } from '@api/crm/crm';
import SelectUser from '@comm/SelectUser';
import SelectCustom from '../SelectCustom';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.uuid) {
      this.getBusiness();
    }
  }

  getBusiness = () => {
    queryBusinessInfo({
      uuid: this.props.uuid,
    }).then(() => {});
  };

  getCustom = params => {
    return new Promise((resolve, reject) => {
      queryCustomList({ ...params }).then(res => {
        if (res.statusCode === 200) {
          resolve(res.data);
        } else {
          reject(res);
        }
      });
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handleSubmit({
          ...values,
          protectionMaturityDate: values.protectionMaturityDate.format('YYYY-MM-DD'),
        });
      }
    });
  };

  handleSelectChangge = () => {
    return (value, selectedOptions) => {
      this.props.form.setFieldsValue({
        protectionUserName: selectedOptions.props.children,
      });
    };
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { handleModalVisible } = this.props;
    getFieldDecorator('protectionUserName');

    return (
      <Modal
        title="添加客户保护"
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.submit}
      >
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <SelectCustom {...this.props} ItemLayout={{}} loaddata={this.getCustom} />
            </Col>
            <Col span={24}>
              <FormItem label="保护时间">
                {getFieldDecorator('protectionMaturityDate', {
                  rules: [{ required: true, message: '请选择联阶段类型!' }],
                })(<DatePicker style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <SelectUser
                {...this.props}
                field={{
                  field: 'protectionUser',
                  fieldName: '保护人',
                  isRequire: true,
                }}
                data={{}}
                onChange={this.handleSelectChangge()}
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/protectWatch/ModalProtect.js